import React from 'react';
import { useLanguage } from '../i18nContext';
import StaticPageLayout from './StaticPageLayout';

interface Props { onBack: () => void; }

export default function TermsPage({ onBack }: Props) {
  const { language } = useLanguage();
  const en = language === 'en';

  return (
    <StaticPageLayout title={en ? 'Terms of Service' : '服务条款'} onBack={onBack}>
      <div className="bg-white rounded-2xl border border-surface-border p-8 md:p-12">
        <h2 className="text-3xl font-bold text-brand-900 font-serif mb-2">{en ? 'Terms of Service' : '服务条款'}</h2>
        <p className="text-sm text-ink-muted mb-8">{en ? 'Last updated: February 2026' : '最后更新：2026 年 2 月'}</p>

        <div className="space-y-8 text-ink-secondary leading-relaxed">
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '1. Acceptance of Terms' : '1. 条款接受'}</h3>
            <p>{en ? 'By accessing or using Minutes AI, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.' : '访问或使用 Minutes AI 即表示您同意受这些服务条款的约束。如果您不同意，请勿使用我们的服务。'}</p>
          </section>
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '2. Service Description' : '2. 服务描述'}</h3>
            <p>{en ? 'Minutes AI provides AI-powered meeting transcription, analysis, and note generation services. We reserve the right to modify or discontinue features with reasonable notice.' : 'Minutes AI 提供 AI 驱动的会议转录、分析和纪要生成服务。我们保留在合理通知后修改或停止功能的权利。'}</p>
          </section>
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '3. User Accounts' : '3. 用户账户'}</h3>
            <p>{en ? 'You are responsible for maintaining the security of your account credentials. You must not share your account or allow unauthorized access.' : '您有责任维护账户凭证的安全。您不得共享账户或允许未经授权的访问。'}</p>
          </section>
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '4. Content Ownership' : '4. 内容所有权'}</h3>
            <p>{en ? 'You retain ownership of all content you upload. We do not claim ownership of your meeting recordings or generated notes.' : '您保留上传的所有内容的所有权。我们不主张对您的会议录音或生成的纪要拥有所有权。'}</p>
          </section>
          <section>
            <h3 className="text-lg font-bold text-brand-900 mb-2">{en ? '5. Payment & Refunds' : '5. 支付与退款'}</h3>
            <p>{en ? 'Paid subscriptions are billed according to the plan selected. Refund requests are handled on a case-by-case basis within 7 days of purchase.' : '付费订阅按所选计划计费。退款请求在购买后 7 天内逐案处理。'}</p>
          </section>
        </div>
      </div>
    </StaticPageLayout>
  );
}
